/*
* Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
  */

export const parsePaginatedResponse = <T = any>(response: any, resourceKey: string): { data: T[]; current_page: number; per_page: number; total: number } => {
    const payload = response?.data ?? response;
    const node = payload?.[resourceKey] ?? response?.[resourceKey];

    const data: T[] | undefined = Array.isArray(node)
        ? (node as any)
        : Array.isArray(node?.data)
            ? node.data
            : undefined;

    const current_page: number | undefined = node?.current_page ?? payload?.current_page;
    const per_page: number | undefined = node?.per_page ?? payload?.per_page;
    const total: number | undefined = node?.total ?? payload?.total;

    if (Array.isArray(data) && typeof current_page === 'number' && typeof per_page === 'number' && typeof total === 'number') {
        return { data, current_page, per_page, total };
    }

    throw response;
};

export default parsePaginatedResponse;
